import { scrollToTop } from '@frontend/libs/utils'
import { ArrowUpIcon } from '@heroicons/react/24/outline'
import { Button } from '@nextui-org/react'
import { useEffect, useRef, useState } from 'react'

function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false)
  const backTopRef = useRef(null)

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 20) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', toggleVisibility)

    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  return (
    <Button
      className={`fixed bottom-10 right-10 z-50 h-auto w-auto bg-white p-4 transition-all duration-200 ${
        isVisible
          ? 'visible translate-y-0 transform opacity-100'
          : 'translate-y-15 invisible transform opacity-0'
      }`}
      color="primary"
      id="back-top"
      isIconOnly
      onClick={scrollToTop}
      ref={backTopRef}
      variant="bordered"
    >
      <ArrowUpIcon className="h-5 w-5" />
    </Button>
  )
}

export default BackToTopButton
